export default __webpack_public_path__ + "static/media/recentlyupdated.fa727489.svg";